module.exports = __webpack_public_path__ + "static/media/einvoice-completed.3e08db06.svg";